export function useFlightType({ dispatch, value, initValue }) {
  const onChange = (selectedType) => {
    dispatch({ type: 'FLIGHT_TYPE_CHANGE', payload: selectedType.value });
  };

  return { value, defaultValue: value, onChange, isChanged: initValue !== value };
}
